<template>
  <v-dialog v-model="show" persistent width="800">
    <v-card :loading="isLoading">
      <v-card-title class="headline">{{ "GỘP SẢN PHẨM" }}</v-card-title>
      <br />
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="6">
              <div class="label-form">Chọn sản phẩm</div>
              <v-autocomplete
                v-model="form.selectedProduct"
                placeholder="Chọn sản phẩm"
                :items="listProduct"
                outlined
                item-text="name"
                item-value="id"
                dense
                return-object
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <div class="label-form">Chọn sản phẩm gộp</div>
              <v-autocomplete
                v-model="form.selectedOtherProduct"
                placeholder="Chọn sản phẩm gộp"
                :items="listProduct"
                outlined
                item-text="name"
                item-value="id"
                dense
                multiple
                return-object
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <div>
                <ul style="text-decoration: none;">
                  <li>
                    <p>Mã sản phẩm :{{ form.selectedProduct.code }}</p>
                  </li>
                  <li>
                    <p>Tên sản phẩm :{{ form.selectedProduct.name }}</p>
                  </li>
                </ul>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <p>Danh sách sản phẩm chọn để gộp</p>
                <ul style="text-decoration: none;">
                  <li v-for="item in form.selectedOtherProduct" :key="item.id">
                    <p>{{ item.name }}</p>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false" class="mr-4">Đóng</v-btn>
        <!--   
        <v-btn
          :loading="btnLoading"
          color="primary"
          @click="addItem"
          v-if="!edit"
        >
          <v-icon left>mdi-plus</v-icon>
          Thêm mới
        </v-btn>
        <v-btn :loading="btnLoading" color="primary" @click="editItem" v-else>
          <v-icon left>mdi-pencil</v-icon>
          Cập nhật
        </v-btn>-->
        <v-btn :loading="isLoading" color="primary" @click="mergeProducts">
          <v-icon left>mdi-pencil</v-icon>
          Cập nhật
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mergeProduct } from "@/api/sanpham";
import chatthaiApi from "@/api/sx.chatthai.api";
export default {
  props: {
    listProduct: {
      type: Array,
    },
  },
  data: () => ({
    isLoading: false,
    show: false,
    form: {
      selectedProduct: {},
      selectedOtherProduct: [],
    },
  }),
  computed: {},
  methods: {
    showFormImport() {
      this.show = true;
      this.form = {
        selectedProduct: {},
        selectedOtherProduct: [],
      };
    },
    getChangeNeedId() {
      const changeNeedIds = this.form.selectedOtherProduct.map(
        (item) => item.id
      );
      return changeNeedIds;
    },
    async mergeProducts() {
      this.isLoading = true;

      let data = {
        target_id: this.form.selectedProduct.id,
        change_needed_ids: this.getChangeNeedId(),
      };
      console.log(data, 3333);
      try {
        const res = await chatthaiApi.mergeProduct(data);

        if (!res.error) {
          this.$emit("on-done");
          this.isLoading = false;
          this.show = false;
        }
      } catch (error) {
        this.errorNotify("Lỗi gộp");
        this.show = true;
        this.isLoading = false;
      }
    },
    errorNotify(message) {
      this.$toast.error(message, {
        position: "top-center",
        timeout: 1500,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
      });
    },
  },
};
</script>
